// Statically embedded Python FullControl wrapper (mirrors public/fullcontrol_wrapper.py)
// Update this file when changing the Python scaffold to avoid a runtime fetch.

export const PY_FULLCONTROL_WRAPPER = String.raw`import fullcontrol as fc
import plotly.graph_objects as go
import math
import traceback

printer_name = 'generic'
printer_settings = {
    'primer': 'travel',
    'print_speed': 40*60,
    'travel_speed': 80*60,
    'nozzle_temp': 210,
    'bed_temp': 50,
    'fan_percent': 100,
    'extrusion_width': 0.4,
    'extrusion_height': 0.2
}

steps = []

user_code_error = None

try:
    ##############################
{userCode}
    ##############################
except Exception:
    user_code_error = traceback.format_exc()

if user_code_error:
    flat_steps = []
else:
    try:
        # Debug: Print steps count before flattening
        print(f"Debug: steps count before flattening: {len(steps)}")
        flat_steps = fc.flatten(steps)
        print(f"Debug: flat_steps count: {len(flat_steps)}")
    except Exception:
        user_code_error = "Error flattening steps: " + traceback.format_exc()
        flat_steps = []

plot_error = None
try:
    plot_result = None
    if flat_steps:
        point_steps = flat_steps
        if point_steps:
            enhanced_steps = [fc.Extruder(on=False)] + point_steps + [fc.Extruder(on=True), fc.Extruder(on=False)]
            plot_controls = fc.PlotControls(raw_data=True, style='line', line_width=2)
            plot_data = fc.transform(enhanced_steps, 'plot', plot_controls)
            if plot_data is not None and hasattr(plot_data, 'paths') and len(plot_data.paths) > 0:
                fig = go.Figure()
                for i, path in enumerate(plot_data.paths):
                    if hasattr(path, 'xvals') and len(path.xvals) > 0:
                        is_extruding = (hasattr(path, 'extruder') and hasattr(path.extruder, 'on') and path.extruder.on)
                        line_color = 'gray'
                        if is_extruding:
                            line_color = path.color if hasattr(path, 'color') else '#1ebb45'
                        line_width = 4 if is_extruding else 2
                        fig.add_trace(go.Scatter3d(
                            x=path.xvals,
                            y=path.yvals,
                            z=path.zvals,
                            mode='lines+markers',
                            line=dict(color=line_color, width=line_width),
                            marker=dict(size=3, color=line_color),
                            name=f"{'Extrude' if is_extruding else 'Travel'} {i}",
                            showlegend=True,
                            opacity=0.8
                        ))
                if hasattr(plot_data, 'bounding_box'):
                    bbox = plot_data.bounding_box
                    x_range = bbox.maxx - bbox.minx if (hasattr(bbox, 'maxx') and bbox.maxx is not None and hasattr(bbox, 'minx') and bbox.minx is not None) else 10
                    y_range = bbox.maxy - bbox.miny if (hasattr(bbox, 'maxy') and bbox.maxy is not None and hasattr(bbox, 'miny') and bbox.miny is not None) else 10
                    z_range = bbox.maxz - bbox.minz if (hasattr(bbox, 'maxz') and bbox.maxz is not None and hasattr(bbox, 'minz') and bbox.minz is not None) else 1
                    max_range = max(x_range, y_range, z_range) + 2
                    x_center = (bbox.maxx + bbox.minx) / 2 if (hasattr(bbox, 'maxx') and bbox.maxx is not None and hasattr(bbox, 'minx') and bbox.minx is not None) else 5
                    y_center = (bbox.maxy + bbox.miny) / 2 if (hasattr(bbox, 'maxy') and bbox.maxy is not None and hasattr(bbox, 'miny') and bbox.miny is not None) else 5
                    z_center = (bbox.maxz + bbox.minz) / 2 if (hasattr(bbox, 'maxz') and bbox.maxz is not None and hasattr(bbox, 'minz') and bbox.minz is not None) else 0
                    fig.update_layout(scene=dict(
                        xaxis=dict(range=[x_center - max_range/2, x_center + max_range/2]),
                        yaxis=dict(range=[y_center - max_range/2, y_center + max_range/2]),
                        zaxis=dict(range=[z_center - max_range/2, z_center + max_range/2]),
                        aspectmode='cube'
                    ))
                fig.update_layout(template='plotly_dark', paper_bgcolor='black', scene_camera=dict(eye=dict(x=1.5, y=1.5, z=1.5)), width=800, height=600, margin=dict(l=10, r=10, b=10, t=10, pad=4))
                plot_data_json = [trace.to_plotly_json() for trace in fig.data]
                layout_dict = fig.layout.to_plotly_json() if hasattr(fig.layout, 'to_plotly_json') else dict(fig.layout)
                plot_result = {'data': plot_data_json, 'layout': layout_dict}
except Exception as e:
    plot_result = None
    plot_error = f"Error generating plot data: {e}"
    print(plot_error)

gcode_error = None
try:
    gcode_result = None
    if flat_steps:
        gcode_result = fc.transform(flat_steps, 'gcode', fc.GcodeControls(printer_name=printer_name, initialization_data=printer_settings))
except Exception as e:
    gcode_result = None
    gcode_error = f"Error generating G-code: {e}"
    print(gcode_error)

result = { 
    'steps': flat_steps, 
    'plot': plot_result, 
    'gcode': gcode_result, 
    'error': user_code_error,
    'plot_error': plot_error,
    'gcode_error': gcode_error
}
result`;
